export const removeFromCart = async ({ BeURL, courseId }) => {
    try {
        if (!BeURL || typeof BeURL !== 'string') {
            alert("Backend URL not provided or invalid")
            return { success: false, message: "Backend URL not provided or invalid" }
        }

        if (!courseId || typeof courseId !== 'string') {
            alert("Course id not provided")
            return { success: false, message: "Course id not provided" }
        }

        const res = await fetch(`${BeURL}/remove-from-cart`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ courseId })
        })

        const data = await res.json()

        if (!data?.success) {
            alert(data?.message || "Failed to remove course from cart")
        }

        return data
    } catch (error) {
        console.error("Error removing from cart:", error)
        alert("An error occurred while removing from cart.")
        return { success: false, message: "An error occurred while removing from cart." }
    }
}
